define(function (require) {
	
	const itemView = require('./v_itv_action_data_item');
	const IPSCollection = require('civicsBase/ipsModelCollection');
	
	const standardCard = require('../../standard/views/v_cpv_card_view');

	return standardCard.extend({
		childView: itemView,
		childViewOptions: function (model) {
			return {
				callback: this.callbacks[model.get('index')]
			};
		},
		initialize: function (options) {
			this.config = options;
			if (options.data.length > 0) {
				//the callbacks are on the data object. when this is converted into a collection, 
				//the functions are removed. We need to pass them in separately to the child view.
				//to accomplish this, we'll add an index attribute so we can match things up.
				this.callbacks = [];
				$.each(options.data, (index, el) => {
					el.index = index;
					this.callbacks.push(el.callback);
				});

				this.collection = new IPSCollection(options.data);
			}
		},
	});
});
